import { useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 768

/**
 * Subscribes to media query changes for mobile breakpoint detection.
 */
function subscribe(callback: () => void) {
	const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
	mql.addEventListener('change', callback)
	return () => mql.removeEventListener('change', callback)
}

/**
 * Returns current mobile state based on window width.
 */
function getSnapshot() {
	return window.innerWidth < MOBILE_BREAKPOINT
}

/**
 * Returns default mobile state for server-side rendering.
 */
function getServerSnapshot() {
	return false
}

/**
 * Hook that detects if the current viewport is mobile-sized (< 768px).
 * Uses `useSyncExternalStore` to subscribe to window resize events and media query changes.
 *
 * @returns `true` if viewport width is below mobile breakpoint, `false` otherwise
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isMobile = useIsMobile()
 *   return <div>{isMobile ? 'Mobile view' : 'Desktop view'}</div>
 * }
 * ```
 */
export function useIsMobile() {
	const isMobile = useSyncExternalStore(
		subscribe,
		getSnapshot,
		getServerSnapshot,
	)

	return isMobile
}
